import { defineStore } from 'pinia';

const DEFAULT_VARIANT = 'info';

export const useNotificationsStore = defineStore({
  id: 'notificationsStore',
  state: () => {
    return {
      notifications: new Map(),
      activeNotification: null,
    };
  },
  actions: {
    addNotification(notificationParams) {
      const {
        notificationMessageTemplate,
        variant = DEFAULT_VARIANT,
        additionalButtons,
        showManageJobsButton,
        key,
      } = notificationParams;

      this.notifications.set(key, {
        additionalButtons,
        notificationMessageTemplate,
        variant,
        showManageJobsButton,
      });
    },
    popNotification(key) {
      this.notifications.delete(key);
      if (this.activeNotification?.key === key) {
        this.resetActiveNotification();
      }
    },
    resetNotifications() {
      this.notifications.clear();
      this.resetActiveNotification();
    },
    setActiveNotification(key) {
      this.activeNotification = {
        key: key,
        value: this.notifications.get(key),
      };
    },
    resetActiveNotification() {
      this.activeNotification = null;
    },
  },
  getters: {
    /**
     * Return the active notification if it has been set
     * Otherwise convert map into array, pop last element and return
     * @param {Object} state
     * @returns activeNotification || last element in map
     */
    getActiveNotification: (state) => {
      if (state.notifications.size <= 0) {
        return;
      }

      if (state.activeNotification) {
        return state.activeNotification;
      }

      const entries = [...state.notifications.entries()].pop();

      return {
        key: entries[0],
        value: entries[1],
      };
    },
  },
});
